import { authenticatedJson } from '../utils/guestSession';
import { functionsBaseUrl } from '../config/runtime';
export async function openJobFiles(job, demo = false) {
    if (demo) throw new Error('Downloads are disabled in the local test view.');
    const files = (job.files || []).map((file,index)=>({file,index})).filter(item=>item.file.storagePath);
    if (!files.length) throw new Error('No downloadable files are available for this job.');
    const popup = window.open('about:blank','_blank');
    if (!popup) throw new Error('Allow pop-ups for this site to download files.');
    popup.opener = null;
    try {
        const links = await Promise.all(files.map(async({file,index})=>({file,...await authenticatedJson(`${functionsBaseUrl}/getPrintJobDownloadUrl`,{jobId:job.id,fileIndex:index})})));
        if (links.length === 1) { popup.location.assign(links[0].url); return; }
        const doc=popup.document;doc.title='Print job files';doc.body.style.cssText='font-family:Arial,sans-serif;max-width:720px;margin:40px auto;padding:20px';
        const heading=doc.createElement('h1');heading.textContent=`Files for job ${job.collectionCode || job.id}`;doc.body.appendChild(heading);
        for(const {file,url} of links){const row=doc.createElement('p');const a=doc.createElement('a');a.href=url;a.textContent=`Download ${file.name}`;a.download=file.name;row.appendChild(a);doc.body.appendChild(row);}
    } catch(error) {popup.close();throw error;}
}
